import {
  NavigateOptions,
  useLocation,
  useNavigate,
  To,
} from 'react-router-dom';
import queryString from 'query-string';

export const useRouter = () => {
  let navigator = useNavigate();
  let { search, state, hash, pathname } = useLocation();

  return {
    navigate: {
      back: () => navigator(-1),
      dblBack: () => navigator(-2),
      trplBack: () => navigator(-3),
      push: (to: To, options?: NavigateOptions) =>
        navigator(to + search, options),
      pushLogin: () => navigator('/login' + search),
      pushHere: (options?: NavigateOptions) =>
        navigator(pathname + search, options),
    },
    history: {
      state: { ...state },
      pathName: () => pathname,
      params: () => search,
      paramsParse: () => queryString.parse(search),
      hash: () => hash,
      hashParse: () => queryString.parse(hash),
    },
  };
};
